import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import { components } from './components';
const renderInternal = ({ elementReference, component, templateData = [], each, }) => {
    let targetHtmlReference;
    if (!each) {
        targetHtmlReference = document.getElementById(elementReference);
    }
    else {
        targetHtmlReference = document.getElementsByClassName(elementReference);
    }
    if (targetHtmlReference) {
        if (HTMLCollection.prototype.isPrototypeOf(targetHtmlReference)) {
            for (let i = 0; i < targetHtmlReference.length; i++) {
                const data = {};
                templateData?.forEach((attribute) => {
                    data[attribute] = getData(targetHtmlReference[i], attribute);
                });
                const Component = component;
                createRoot(targetHtmlReference[i]).render(_jsx(Component, { templateData: data }));
            }
        }
        else {
            const data = {};
            templateData?.forEach((attribute) => {
                data[attribute] = getData(targetHtmlReference, attribute);
            });
            const Component = component;
            createRoot(targetHtmlReference).render(_jsx(Component, { templateData: data }));
        }
    }
};
export const render = ({ customToRender = {} }) => {
    Object.entries({ ...components, ...customToRender }).forEach(([key, { component, templateData, each }]) => {
        renderInternal({
            elementReference: key,
            component,
            templateData,
            each,
        });
    });
};
const getData = (element, attribute) => {
    if (!attribute)
        return undefined;
    const data = element.getAttribute(attribute);
    if (!data)
        return undefined;
    try {
        return JSON.parse(data);
    }
    catch (err) {
        return data;
    }
};
